module.exports = __webpack_public_path__ + "static/media/vicky.9ac4f10e.png";